import { useState, useEffect, useCallback } from 'react';
import api from '../api';
import { useLab } from '../i18n/LabContext';

export default function PendingDevices() {
  const { labId } = useLab();
  const [items, setItems] = useState([]);
  const [computers, setComputers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(null); // { device, mode: 'link'|'new' }
  const [selectedComputerId, setSelectedComputerId] = useState('');
  const [newNumber, setNewNumber] = useState('');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const q = labId ? `?lab_id=${labId}` : '';
      const [{ data: d }, { data: cs }] = await Promise.all([
        api.get(`/owner/pending-devices${q}`),
        api.get(`/owner/computers${q}`),
      ]);
      setItems(d || []);
      setComputers(cs || []);
    } catch (e) {
      console.error(e);
    } finally { setLoading(false); }
  }, [labId]);

  useEffect(() => {
    load();
    const t = setInterval(load, 10000); // har 10 sek yangilash
    return () => clearInterval(t);
  }, [load]);

  const openLink = (device) => { setModal({ device, mode: 'link' }); setSelectedComputerId(''); setNewNumber(''); setErr(''); };
  const openNew  = (device) => { setModal({ device, mode: 'new'  }); setSelectedComputerId(''); setNewNumber(''); setErr(''); };
  const close    = () => { setModal(null); setErr(''); };

  const submit = async () => {
    if (!modal) return;
    setSaving(true); setErr('');
    try {
      const body = modal.mode === 'new'
        ? { create_new: true, computer_number: parseInt(newNumber) }
        : { computer_id: parseInt(selectedComputerId) };
      await api.post(`/owner/pending-devices/${modal.device.id}/link`, body);
      close();
      load();
    } catch (e) {
      setErr(e.response?.data?.error || e.message);
    } finally { setSaving(false); }
  };

  const reject = async (id) => {
    if (!window.confirm('Qurilmani rad etasizmi? Agent qayta so\'rov yuborsa ham qabul qilinmaydi.')) return;
    try {
      await api.post(`/owner/pending-devices/${id}/reject`);
      load();
    } catch (e) {
      alert(e.response?.data?.error || e.message);
    }
  };

  const fmtTime = (t) => {
    if (!t) return '-';
    const d = new Date(t);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return `${Math.round(diff)}s`;
    if (diff < 3600) return `${Math.round(diff / 60)} daq`;
    if (diff < 86400) return `${Math.round(diff / 3600)} s`;
    return d.toLocaleString();
  };

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ margin: 0 }}>🆕 Yangi qurilmalar</h1>
        <button onClick={load} disabled={loading} style={{ padding: '6px 12px' }}>
          {loading ? 'Yuklanmoqda...' : '↻ Yangilash'}
        </button>
      </div>

      <p style={{ color: 'var(--muted, #666)', marginTop: 0 }}>
        Diskless (qattiq disksiz) PC'lar birinchi marta tarmoqqa ulanganida shu yerga tushadi.
        Admin ularni mavjud PC raqamiga bog'lashi yoki yangi raqam bilan qo'shishi mumkin.
      </p>

      {items.length === 0 ? (
        <div style={{ padding: 32, textAlign: 'center', color: '#888', border: '1px dashed #ccc', borderRadius: 8 }}>
          Hozircha yangi qurilma yo'q. Agent 15 soniyada bir marta so'rov yuboradi.
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: 'var(--bg2, #f5f5f5)' }}>
              <th style={{ padding: 8, textAlign: 'left' }}>MAC</th>
              <th style={{ padding: 8, textAlign: 'left' }}>Hostname</th>
              <th style={{ padding: 8, textAlign: 'left' }}>IP</th>
              <th style={{ padding: 8, textAlign: 'left' }}>BIOS UUID</th>
              <th style={{ padding: 8, textAlign: 'left' }}>So'ralgan</th>
              <th style={{ padding: 8, textAlign: 'left' }}>Amallar</th>
            </tr>
          </thead>
          <tbody>
            {items.map(d => (
              <tr key={d.id} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: 8, fontFamily: 'monospace' }}>{d.mac_address || <em>MAC yo'q</em>}</td>
                <td style={{ padding: 8 }}>{d.hostname || '-'}</td>
                <td style={{ padding: 8, fontFamily: 'monospace', fontSize: 12 }}>{d.ip || '-'}</td>
                <td style={{ padding: 8, fontFamily: 'monospace', fontSize: 11 }}>
                  {d.hardware_uuid ? d.hardware_uuid.slice(0, 18) + '…' : '-'}
                </td>
                <td style={{ padding: 8 }} title={new Date(d.requested_at).toLocaleString()}>
                  {fmtTime(d.updated_at)}
                </td>
                <td style={{ padding: 8 }}>
                  <button onClick={() => openLink(d)} disabled={!d.mac_address} style={{ marginRight: 6 }}>
                    🔗 PC ga bog'lash
                  </button>
                  <button onClick={() => openNew(d)} disabled={!d.mac_address} style={{ marginRight: 6 }}>
                    ➕ Yangi PC
                  </button>
                  <button onClick={() => reject(d.id)} style={{ color: 'var(--red, #c00)' }}>
                    ❌ Rad etish
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'var(--bg, #fff)', padding: 24, borderRadius: 8, minWidth: 400, maxWidth: 500 }}>
            <h2 style={{ marginTop: 0 }}>
              {modal.mode === 'new' ? '➕ Yangi PC sifatida qo\'shish' : '🔗 Mavjud PC ga bog\'lash'}
            </h2>
            <p style={{ color: '#666', margin: '8px 0' }}>
              MAC: <code>{modal.device.mac_address}</code><br />
              Hostname: {modal.device.hostname || '-'}
            </p>
            {modal.mode === 'link' ? (
              <div style={{ margin: '12px 0' }}>
                <label>Qaysi PC ga bog'laymiz?</label>
                <select
                  value={selectedComputerId}
                  onChange={e => setSelectedComputerId(e.target.value)}
                  style={{ width: '100%', padding: 8, marginTop: 4 }}
                >
                  <option value="">— tanlang —</option>
                  {computers
                    .filter(c => c.lab_id === modal.device.lab_id)
                    .sort((a, b) => a.number - b.number)
                    .map(c => (
                      <option key={c.id} value={c.id}>
                        PC #{c.number} {c.mac_address ? `(MAC: ${c.mac_address})` : '(MAC yo\'q)'}
                      </option>
                    ))}
                </select>
                <small style={{ color: '#888' }}>
                  Diqqat: tanlangan PC ning MAC manzili yangisi bilan almashadi.
                </small>
              </div>
            ) : (
              <div style={{ margin: '12px 0' }}>
                <label>Yangi PC raqami (1–999)</label>
                <input
                  type="number"
                  min="1"
                  max="999"
                  value={newNumber}
                  onChange={e => setNewNumber(e.target.value)}
                  style={{ width: '100%', padding: 8, marginTop: 4 }}
                />
              </div>
            )}
            {err && <div style={{ color: 'var(--red, #c00)', margin: '8px 0' }}>{err}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
              <button onClick={close} disabled={saving}>Bekor qilish</button>
              <button onClick={submit} disabled={saving || (modal.mode === 'link' ? !selectedComputerId : !newNumber)}>
                {saving ? 'Saqlanmoqda...' : 'Tasdiqlash'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
